export enum FormStep {
  ChooseIntegrator = 1,
  AccessToken = 2,
}
